import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDriver = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5.923 8.585A.6.6 0 0 1 6.5 8.15h5a.6.6 0 0 1 .577.435l.533 1.865H13a.6.6 0 1 1 0 1.2h-.047l.124.435a.6.6 0 0 1 .022.205l-.2 3a.6.6 0 0 1-.6.56H11a.6.6 0 0 1-.536-.332l-.334-.668H7.871l-.334.668A.6.6 0 0 1 7 15.85H5.7a.6.6 0 0 1-.599-.56l-.2-3a.6.6 0 0 1 .022-.205l.124-.435H5a.6.6 0 1 1 0-1.2h.39l.533-1.865Zm.372 3.065-.085.3H7a.5.5 0 0 1 0 1h-.852l.113 1.7h.368l.334-.668a.6.6 0 0 1 .537-.332h3a.6.6 0 0 1 .537.332l.334.668h.368l.113-1.7H10.5a.5.5 0 1 1 0-1h1.29l-.085-.3h-5.41Zm5.067-1.2H6.638l.314-1.1h4.095l.315 1.1ZM18 11.6a.6.6 0 1 0 0-1.2h-2a.6.6 0 0 0 0 1.2h2Zm1 3a.6.6 0 1 0 0-1.2h-3a.6.6 0 0 0 0 1.2h3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorDriver;
